import { render, staticRenderFns } from "./policyDetailInfo.vue?vue&type=template&id=90e496ea&scoped=true&"
import script from "./policyDetailInfo.vue?vue&type=script&lang=js&"
export * from "./policyDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e496ea",
  null
  
)

export default component.exports